import Dictionary from "app/components/common/helpable/online-help-dictionary";

const DOC_INDEX_PATH = Dictionary.getIndexHTMLPath();
const sampleGroupsDictionary = {
    Samples: {
        description:
            "These sample applications show continuous Real Time data collection, data correlation across multiple sources, data enrichment, and data visualization using Striim. ",
        validations: []
    },
    SamplesDB: {
        description: `These sample applications show continuous data movement using Initial Load, and continuous CDC (Change Data Capture) from one PostgreSQL DB to another. &lt;a href=&quot;${DOC_INDEX_PATH}?contextId=running_the_cdc_sample_apps&quot; target=&quot;_blank&quot;&gt;Read the docs&lt;/a&gt; or &lt;a class=&quot;samples-demo-video&quot;&gt;Watch a Demo Video&lt;/a&gt;`,
        validations: ["postgres"]
    },
    SamplesDB2Kafka: {
        description: `These sample applications show continuous data movement from a PostgreSQL Database using Initial Load and CDC to Kafka. &lt;a href=&quot;${DOC_INDEX_PATH}?contextId=running_the_cdc_sample_apps&quot; target=&quot;_blank&quot;&gt;Read the docs&lt;/a&gt; or &lt;a class=&quot;samples-demo-video&quot;&gt;Watch a Demo Video&lt;/a&gt;`,
        validations: ["postgres", "kafka"]
    },
    SamplesDB2File: {
        description: `These sample applications show continuous data movement from a PostgreSQL Database using Initial Load and CDC to local files. &lt;a href=&quot;${DOC_INDEX_PATH}?contextId=running_the_cdc_sample_apps&quot; target=&quot;_blank&quot;&gt;Read the docs&lt;/a&gt; or &lt;a class=&quot;samples-demo-video&quot;&gt;Watch a Demo Video&lt;/a&gt;`,
        validations: ["postgres"]
    }
};

export default class SampleGreoupsPropertiesProvider {
    static applySampleGroupsProperties(groups) {
        if (!groups || !groups.length) {
            return groups;
        }

        for (let i = 0; i < groups.length; i++) {
            let group = groups[i];
            var sampleGroupProperties = sampleGroupsDictionary[group.name];
            if (!sampleGroupProperties) {
                continue;
            }

            group.description = sampleGroupProperties.description;
            group.validations = sampleGroupProperties.validations;
        }

        return groups;
    }
}
